"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SearchInput_module_css_1 = __importDefault(require("./SearchInput.module.css"));
const react_intl_1 = require("react-intl");
const clsx_1 = __importDefault(require("clsx"));
const SearchIcon_1 = require("../../../icons/SearchIcon");
const CrossCircleIcon_1 = require("../../../icons/CrossCircleIcon");
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
const web_sds_c_1 = require("@snapchat/web-sds-c");
/**
 * Search input: https://www.figma.com/file/o5nUWrWkZQen4HNUD0pDqE/Search-on-Web?type=design&node-id=910-64955&mode=design&t=D3w9SjcVQTP8fjil-0
 */
function SearchInput({ expandOnFocus, onSearch, currentSearchQuery, }) {
    const [query, setQuery] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        currentSearchQuery && setQuery(currentSearchQuery);
    }, [currentSearchQuery]);
    const inputRef = (0, react_1.useRef)(null);
    const intl = (0, react_intl_1.useIntl)();
    const searchCopy = intl.formatMessage({
        id: "3nkhih",
        description: "Search input prompt",
        defaultMessage: "Search",
    });
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            onSearch(query);
        }
    };
    const handleChange = (event) => {
        setQuery(event.target.value);
    };
    const handleContainerClick = () => {
        inputRef.current?.focus();
        void (0, web_graphene_reporting_1.incrementCounter)(`SearchBar.${(0, web_graphene_reporting_1.getDeviceName)()}.Focus`);
    };
    const onClearClick = () => {
        setQuery("");
        void (0, web_graphene_reporting_1.incrementCounter)(`SearchBar.ClearSearch.${(0, web_graphene_reporting_1.getDeviceName)()}.Click`);
    };
    const expandSearchInput = expandOnFocus && query.length === 0;
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, clsx_1.default)(SearchInput_module_css_1.default.container, {
            [SearchInput_module_css_1.default.expandOnFocus]: expandSearchInput,
        }), onClick: handleContainerClick, "data-testid": "searchInputContainer", children: [(0, jsx_runtime_1.jsx)("span", { className: SearchInput_module_css_1.default.inputIcon, "data-testid": "searchInputIcon", children: (0, jsx_runtime_1.jsx)(SearchIcon_1.SearchIcon, { size: "LARGE" }) }), (0, jsx_runtime_1.jsx)("input", { type: "text", placeholder: searchCopy, value: query, onKeyDown: handleKeyDown, onChange: handleChange, className: (0, clsx_1.default)(SearchInput_module_css_1.default.searchInput, {
                    [(0, web_sds_c_1.getClassName)("H7", true)]: true,
                }), ref: inputRef, "data-testid": "searchInputBox" }), query !== "" && ((0, jsx_runtime_1.jsx)("span", { className: (0, clsx_1.default)(SearchInput_module_css_1.default.inputIcon, SearchInput_module_css_1.default.clearIcon), onClick: onClearClick, "data-testid": "searchInputCrossIcon", children: (0, jsx_runtime_1.jsx)(CrossCircleIcon_1.CrossCircleIcon, { size: "MEDIUM" }) }))] }));
}
exports.SearchInput = SearchInput;
//# sourceMappingURL=SearchInput.js.map